/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_PAYMENT_METHODS, GET_PAYMENT_METHODS } from 'src/actions/paymentMethodActions';

const initialState = {
  items: [],
  isFetching: false,
  message: ''
};

const paymentMethodReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PAYMENT_METHODS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_PAYMENT_METHODS: {
      const { paymentMethods, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = paymentMethods;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default paymentMethodReducer;
